import { Card, CardHeader } from "@/components/ui/card";
import { ReactForm } from "./utils";
import { useMutations } from "./utils/react-hook/use-mutations";
import { Label } from "@/components/ui/label";
import { TabsHeader } from "./utils/tabs-header/tabs-header";

export const Setting = () => {
  const {
    companyData,
    onFormSubmit,
    workflowList,
    tabList,
    activeTab,
    setActiveTab,
    sncErpUomList,
    order_status_list,
    sncCustomerList,
    onErpSettingsTabChange,
    reloadData,
    skuList,
  } = useMutations();
  return (
    <Card className="relative overflow-hidden">
      <CardHeader className="flex justify-between items-center flex-row p-0 pt-3">
        <div className="flex items-center gap-5">
          {/* <CardTitle>Settings</CardTitle> */}
          <TabsHeader
            tabList={tabList}
            activeTab={activeTab}
            setActiveTab={(prop: string) => setActiveTab(prop)}
          />
        </div>
        <Label className="pr-5 pb-3">
          <span>Company Name: </span>
          <strong className="capitalize">{companyData?.display_name}</strong>
        </Label>
      </CardHeader>
      <hr />
      <ReactForm
        onFormSubmit={onFormSubmit}
        formData={companyData?.settings}
        workflowList={workflowList}
        activeTab={activeTab}
        sncErpUomList={sncErpUomList}
        order_status_list={order_status_list}
        sncCustomerList={sncCustomerList}
        onErpSettingsTabChange={onErpSettingsTabChange}
        sku_list={skuList}
        reloadData={reloadData}
      />
      <div id="ignore-price-validations-wrapper"></div>
    </Card>
  );
};
